// MpfLabel.props.ts

import { HeadingLevel, InputSize, MpfInputBaseProps } from '../MpfInput/MpfInputBaseProps';

export interface MpfLabelProps extends MpfInputBaseProps {
  forId?: string;
  headingLevel?: HeadingLevel;
  labelClass?: string;
}

export const mpfLabelDefaults = {
  required: false,
  headingLevel: undefined,
  size: 'default' as InputSize,
} satisfies Partial<MpfLabelProps>;
